import React, { useEffect } from 'react';
import store from '@apply/adminStore';
import HmdaSummary from './tables/HmdaSummary';
import { SectionHeader } from '../common/SharedComponents';
import debounce from 'lodash.debounce';
import EditModal from './modals/EditModal';
import ExportModal from './modals/ExportModal';
import { BfiCustomStore } from '../common/SharedComponents';
import ManageDeletedModal from './modals/ManageDeletedModal';

function HmdaLandingPage() {
    const { dispatch } = store;
    const debouncedSearch = debounce(dispatch, 500);
    const hmdaStore = new BfiCustomStore();

    useEffect(() => {
        return () => {
            //Cancel any further searches if component is unloaded
            debouncedSearch.cancel();
        };
    });

    return (
        <>
            <SectionHeader title='HMDA' />
            <div
                className='main-content'
                style={{ padding: 0 }}
            >
                <HmdaSummary hmdaStore={hmdaStore} />
            </div>
            <EditModal />
            <ExportModal />
            <ManageDeletedModal />
        </>
    );
}

export default HmdaLandingPage;
